/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { z } from "zod";

const charactersLength = 2048;

export const isValidUrlSchema = z
  .string()
  .max(charactersLength, "Contact link is too long")
  .refine((link: string) => {
    if (link.length <= 0) {
      return true;
    } else {
      return z.string().url("This contact link is invalid").safeParse(link)
        .success;
    }
  });
